export default "__VITE_ASSET__29ef43a0__"